var map = {
	"./song1.mp3": 283,
	"./song10.mp3": 833,
	"./song11.mp3": 60,
	"./song12.mp3": 395,
	"./song13.mp3": 542,
	"./song14.mp3": 181,
	"./song15.mp3": 904,
	"./song2.mp3": 4,
	"./song3.mp3": 953,
	"./song4.mp3": 602,
	"./song5.mp3": 215,
	"./song6.mp3": 488,
	"./song7.mp3": 773,
	"./song8.mp3": 262,
	"./song9.mp3": 507
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 417;